import axios from '../config/axios';
import { API_ENDPOINTS } from '../config/api';

/**
 * Deterministic protocol writing-style checks (YAML catalog on server).
 */
export async function lintDocument(document, context = {}) {
  const { data } = await axios.post(API_ENDPOINTS.styleCompliance.lintDocument, {
    document,
    context,
  });
  return data;
}

export async function lintSection(section, context = {}) {
  const { data } = await axios.post(API_ENDPOINTS.styleCompliance.lintSection, {
    section,
    context,
  });
  return data;
}

export async function applyAutofix(text, findings) {
  const { data } = await axios.post(API_ENDPOINTS.styleCompliance.applyAutofix, {
    text,
    findings,
  });
  return data;
}
